import { BaseService } from './api'
import {
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  ListApiKeysResponse,
  DeleteApiKeyResponse,
  UsageAnalyticsParams,
  UsageAnalyticsResponse,
  PartnerReferralsResponse,
  PartnerReferralsStats,
  PartnerReferralsFilters,
  PartnerReferralsStatsFilters
} from '@/types'

class PartnerService extends BaseService {
  // API Key Management
  async createApiKey(data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
    return this.post<CreateApiKeyResponse>('/api-keys', data)
  }

  async listApiKeys(): Promise<ListApiKeysResponse> {
    return this.get<ListApiKeysResponse>('/api-keys')
  }

  async deleteApiKey(keyId: string): Promise<DeleteApiKeyResponse> {
    return this.delete<DeleteApiKeyResponse>(`/api-keys/${keyId}`)
  }

  // Usage Analytics
  async getUsageAnalytics(params: UsageAnalyticsParams = {}): Promise<UsageAnalyticsResponse> {
    const queryParams: Record<string, any> = {}
    
    if (params.interval) queryParams.interval = params.interval
    if (params.sort_direction) queryParams.sort_direction = params.sort_direction
    if (params.group_by) queryParams.group_by = params.group_by
    if (params.start_date) queryParams.start_date = params.start_date
    if (params.end_date) queryParams.end_date = params.end_date
    if (params.api_key_ids) queryParams.api_key_ids = params.api_key_ids

    return this.get<UsageAnalyticsResponse>('/partner/usage', { params: queryParams })
  }

  // New methods for Partner Referrals

  async getPartnerReferrals(filters: PartnerReferralsFilters): Promise<PartnerReferralsResponse> {
    return this.get<PartnerReferralsResponse>('/partner/referrals', { params: filters })
  }

  async getPartnerReferralsStats(filters: PartnerReferralsStatsFilters): Promise<PartnerReferralsStats> {
    return this.get<PartnerReferralsStats>('/partner/referrals/stats', { params: filters })
  }
}

export const partnerService = new PartnerService() 